import { jsx as _jsx } from "react/jsx-runtime";
import { classes } from "./classes.js";
/**
 * Broadsheet's `.card`, the system's one boxed component.
 *
 * "Reserve `.card` for genuinely discrete items such as listings, never for layout" —
 * so this wrapper takes no layout props at all. Sections are separated with whitespace.
 */
export const ELEVATIONS = ["none", "sm", "md", "lg"];
export function Card({ elevation = "none", as = "div", children }) {
    const className = classes("card", elevation !== "none" && `elev-${elevation}`);
    if (as === "li")
        return _jsx("li", { className: className, children: children });
    if (as === "article")
        return _jsx("article", { className: className, children: children });
    return _jsx("div", { className: className, children: children });
}
export function CardKicker({ children }) {
    return _jsx("span", { className: "card-kicker", children: children });
}
export function CardTitle({ children, level = 3 }) {
    if (level === 2)
        return _jsx("h2", { className: "card-title", children: children });
    if (level === 4)
        return _jsx("h4", { className: "card-title", children: children });
    return _jsx("h3", { className: "card-title", children: children });
}
export function CardBody({ children }) {
    return _jsx("p", { className: "card-body", children: children });
}
export function CardMeta({ children }) {
    return _jsx("span", { className: "card-meta", children: children });
}
//# sourceMappingURL=card.js.map